import { Circle as CircleOriginal, type CircleProps as CirclePropsOriginal, Square as SquareOriginal, type SquareProps as SquarePropsOriginal, Stack as StackOriginal, type StackProps as StackPropsOriginal, styled, XStack as XStackOriginal, type XStackProps as XStackPropsOriginal, YStack as YStackOriginal, type YStackProps as YStackPropsOriginal } from "tamagui";
import { type ShadowVariant, shadow } from "../themes/token-shadow";
import { hairline } from "../utils";
type VariantProps = {
  border?: boolean;
  shadow?: ShadowVariant;
};
export type YStackProps = VariantProps & YStackPropsOriginal;
export type XStackProps = VariantProps & XStackPropsOriginal;
export type StackProps = VariantProps & StackPropsOriginal;
export type CircleProps = VariantProps & CirclePropsOriginal;
export type SquareProps = VariantProps & SquarePropsOriginal;
export const variantConstants = {
  border: {
    true: {
      borderWidth: hairline,
      borderColor: "$strokeSecondary"
    }
  },
  shadow
} as const;
export const YStack = styled(YStackOriginal, {
  variants: variantConstants
});
export const XStack = styled(XStackOriginal, {
  variants: variantConstants
});
export const Stack = styled(StackOriginal, {
  variants: variantConstants
});
export const Circle = styled(CircleOriginal, {
  variants: variantConstants
});
export const Square = styled(SquareOriginal, {
  variants: variantConstants
});